import { Builder_, Checkbox_, Dates_, Grey_Link, Slider_ } from 'monica-alexandria'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const CallFilterIntro = styled.p`
  color: ${props => props.theme.grey || '#777'};
  margin: 0 0 1.5rem;
`;

const CallFilterGroup = styled.div`
  border-bottom: 1px solid ${props => props.theme.mid || 'rgba(127, 127, 127, 0.18)'};
  padding: 0 0 1.5rem;
  margin-bottom: 1.5rem;

  &:last-of-type {
    border-bottom: 0;
  }

  h4 {
    margin: 0 0 1rem;
  }
`;

const CallFilterOptions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 1rem 2rem;
`;

const normalizeSelectedValues = (value) => {
  if (Array.isArray(value)) return value;
  if (!value || value === 'all') return [];
  return String(value).split(',').filter(Boolean);
};

export default function Crm_Leads_Date(props) {

  const {t} = useTranslation()
  const selectedValues = (key) => normalizeSelectedValues(props.callFilters?.[key]);
  const toggleCallFilter = (key, value) => {
    props.setCallFilters((filters) => {
      const current = normalizeSelectedValues(filters?.[key]);
      return {
        ...filters,
        [key]: current.includes(value)
          ? current.filter((selectedValue) => selectedValue !== value)
          : [...current, value],
      };
    });
  };
  const assigneeOptions = (props.scheduleUsers || [])
    .map((user) => ({
      value: String(user?.userId || user?.id || user?.email || ''),
      label: user?.isCurrentUser
        ? user?.isOwner ? t('Me (owner)') : t('Me')
        : user?.name || [user?.firstname, user?.lastname].filter(Boolean).join(' ') || user?.email,
    }))
    .filter((option, index, options) => option.value && options.findIndex((candidate) => candidate.value === option.value) === index);
    const onChange = (selections) => {

      console.log('selections', selections);
      
        // props.onDates(selections)
        props.setCustomRange({...props.customRange,type:'custom', start: selections[0],end: selections[1], renderedDates: selections})
    }


    console.log('setCustomRange', props.customRange);
    
  return (
    <div> 
        
    <Slider_
        text={t("Done")}
        onClose={()=>props.onClose()}
        title={t("Filter leads")}
        onClick={()=>props.onDone()}
    >
      <Builder_ title={t('Select date range or leave empty for all time leads.')}>
        <Dates_
            allowPartialRange={true}
            onChange={onChange} 
            value={props.customRange?.renderedDates} 
            selectRange={true} 
            dateFullCellRender={(date) => date?.date()} 
            maxDate={new Date()}
        />
        <Grey_Link text={t('Clear dates')} iconLeft='Xicon' onClick={()=> props.setCustomRange({...props.customRange,type:'all',  start: null,end: null, renderedDates: ''})}/>
      </Builder_>
      <Builder_ title={t('Calls')}>
        <CallFilterIntro>{t('Select one or more options. Leave a group empty to include all.')}</CallFilterIntro>
        <CallFilterGroup>
          <h4>{t('Call timing')}</h4>
          <CallFilterOptions>
            {[
              ['overdue', 'Overdue'],
              ['today', 'Today'],
              ['upcoming', 'Upcoming'],
              ['none', 'No call scheduled'],
            ].map(([value, label]) => (
              <Checkbox_
                key={value}
                type="checkbox"
                text={t(label)}
                checked={selectedValues('timing').includes(value)}
                onClick={() => toggleCallFilter('timing', value)}
              />
            ))}
          </CallFilterOptions>
        </CallFilterGroup>
        <CallFilterGroup>
          <h4>{t('Assigned to')}</h4>
          <CallFilterOptions>
            {assigneeOptions.map((option) => (
              <Checkbox_
                key={option.value}
                type="checkbox"
                text={option.label}
                checked={selectedValues('assignee').includes(option.value)}
                onClick={() => toggleCallFilter('assignee', option.value)}
              />
            ))}
          </CallFilterOptions>
        </CallFilterGroup>
        <CallFilterGroup>
          <h4>{t('Previous call result')}</h4>
          <CallFilterOptions>
            {[
              ['connected', 'Connected'],
              ['no_answer', 'No answer'],
              ['voicemail', 'Left voicemail'],
              ['wrong_number', 'Wrong number'],
              ['cancelled', 'Cancelled'],
            ].map(([value, label]) => (
              <Checkbox_
                key={value}
                type="checkbox"
                text={t(label)}
                checked={selectedValues('outcome').includes(value)}
                onClick={() => toggleCallFilter('outcome', value)}
              />
            ))}
          </CallFilterOptions>
        </CallFilterGroup>
        <Grey_Link
          text={t('Clear call filters')}
          iconLeft='Xicon'
          onClick={() => props.setCallFilters({ timing: [], assignee: [], outcome: [] })}
        />
      </Builder_>
    </Slider_></div>
  )
}
